<template>
  <StepLayout
    :title="`${keyword}に関して症状はいつ頃から始まりましたか？`"
    :current-step="2"
    @back="handleBack"
  >
    <OptionList
      v-model="model"
      :options="durationOptions"
      aria-label="症状の期間の選択"
      @select="handleSelect"
    />

    <template #skip>
      <SkipLink label="質問をスキップ" @click="handleSkip" />
    </template>
  </StepLayout>
</template>

<script setup lang="ts">
import StepLayout from './StepLayout.vue';
import OptionList from './OptionList.vue';
import SkipLink from './SkipLink.vue';
import type { DurationOption } from '../types';

defineProps<{
  keyword: string;
}>();

const model = defineModel<DurationOption | null>({ default: null });

const emit = defineEmits<{
  next: [];
  back: [];
  skip: [];
}>();

const durationOptions = [
  { value: 'today', label: '今日初めて気づいた' },
  { value: 'yesterday', label: '昨日から' },
  { value: 'few_days', label: '2,3日以内' },
  { value: 'within_week', label: '1週間以内から' },
  { value: 'over_week', label: '1週間以上前から' },
  { value: 'no_symptom', label: '症状は無い・当てはまらない' },
];

const handleSelect = () => {
  emit('next');
};

const handleBack = () => {
  emit('back');
};

const handleSkip = () => {
  emit('skip');
};
</script>

<style lang="scss" scoped>
// StepLayout provides all common styling
</style>
